if($('.products').length){
	function mhproduct(){
		$('.product').each(function(){
			var addtocart = '<span class="quantity"><input type="text" name="amount" value="1" class="amount" autocomplete="off" data-decimals="0" data-max="9999" data-min="1" aria-label="Amount"><span class="increase" title="Increase a quantity"></span><span class="decrease" title="Decrease a quantity"></span></span>'
			if($(this).find('.p-tools button').length){
                if($(this).find('.p-tools .pr-action .quantity').length == 0){
                    $(this).find('.p-tools .pr-action').prepend(addtocart)
                }
            }
            else{

            }
            if(!getShoptetDataLayer('customer').registered){
                $(this).find('.p-tools').remove()
            }
		});
	};

	mhproduct();

	document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    	mhproduct();
	});
	$(document).on("ShoptetDOMAdvancedOrderLoaded",function(){
		mhproduct();	
	});
	document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
    	mhproduct();
	});
	
}
